<template>
  <v-layout align-center column style="margin-top: 100px;">
    <p class="Section-Title">Cara Kerja Pendanaan</p>
    <div class="Desc">
      Dompet Kilat menyalurkan pinjaman non tunai pada pelaku usaha secara
      langsung melalui
      <span style="Desc" v-bind:style="{ 'font-weight': 'bold' }"
        >Ekosistem Kerja Sama</span
      >. Kami juga menggunakan sistem asuransi agar uang kamu
      <span style="Desc" v-bind:style="{ 'font-weight': 'bold' }"
        >aman bersama Dompet Kilat!</span
      >
    </div>
    <div>
      <v-skeleton-loader
        type="image"
        class="Diagram"
        v-if="!isImgLoaded"
      ></v-skeleton-loader>
      <img
        src="../../assets/pendanaan/Diagram.png"
        srcset="
          ../../assets/pendanaan/Diagram@2x.png 2x,
          ../../assets/pendanaan/Diagram@3x.png 3x
        "
        @load="onImgLoad"
        class="Diagram"
      />
    </div>
    <v-row v-if="widthNow >= 1200" justify="center">
      <v-col>
        <div class="Shape">
          <div class="Ellipse">
            <p class="Value">1</p>
          </div>
          <p class="Detail">
            Dompet Kilat memberikan factsheet atas hasil verifikasi calon
            peminjam kepada Pendana.
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="Shape">
          <div class="Ellipse">
            <p class="Value">2</p>
          </div>
          <p class="Detail">
            Pendana melakukan transfer sejumlah dana yang akan diinvestasikan
            kepada escrow Dompet Kilat.
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="Shape">
          <div class="Ellipse">
            <p class="Value">3</p>
          </div>
          <p class="Detail" v-bind:style="{ width: '220px', margin: 'auto' }">
            Dompet Kilat akan meneruskan dana kepihak ke-3 (tiga) untuk memenuhi
            kebutuhan Peminjam
          </p>
        </div>
      </v-col>
      <v-col>
        <div class="Shape">
          <div class="Ellipse">
            <p class="Value">4</p>
          </div>
          <p class="Detail">
            Peminjam mengembalikan dana kepada Dompet Kilat sesuai dengan
            kesepakatan perjanjian untuk diteruskan ke pendana
          </p>
        </div>
      </v-col>
    </v-row>
    <div v-if="widthNow <= 1200">
      <div class="Shape" style="margin-bottom: 30px;">
        <div class="Ellipse">
          <p class="Value">1</p>
        </div>
        <p class="Detail">
          Dompet Kilat memberikan factsheet atas hasil verifikasi calon peminjam
          kepada Pendana.
        </p>
      </div>
      <div class="Shape" style="margin-bottom: 30px;">
        <div class="Ellipse">
          <p class="Value">2</p>
        </div>
        <p class="Detail">
          Pendana melakukan transfer sejumlah dana yang akan diinvestasikan
          kepada escrow Dompet Kilat.
        </p>
      </div>
      <div class="Shape" style="margin-bottom: 30px;">
        <div class="Ellipse">
          <p class="Value">3</p>
        </div>
        <p class="Detail" v-bind:style="{ width: '220px', margin: 'auto' }">
          Dompet Kilat akan meneruskan dana kepihak ke-3 (tiga) untuk memenuhi
          kebutuhan Peminjam
        </p>
      </div>
      <div class="Shape">
        <div class="Ellipse">
          <p class="Value">4</p>
        </div>
        <p class="Detail">
          Peminjam mengembalikan dana kepada Dompet Kilat sesuai dengan
          kesepakatan perjanjian untuk diteruskan ke pendana
        </p>
      </div>
    </div>
  </v-layout>
</template>
<script>
export default {
  data() {
    return {
      widthNow: window.innerWidth,
      isImgLoaded: false,
    };
  },

  methods: {
    onImgLoad() {
      this.isImgLoaded = true;
    },
  },
};
</script>
<style scoped>
.Section-Title {
  width: 271px;
  height: 30px;
  flex-grow: 0;
  margin: 0px auto 24px auto;
  font-family: Sora;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Desc {
  width: 742px;
  height: 66px;
  flex-grow: 0;
  margin: 24px auto 0 auto;
  font-family: Sora;
  font-size: 16px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}

.Desc .text-style-1 {
  font-weight: bold;
}
.Diagram {
  max-width: 1048px;
  max-height: 589px;
  flex-grow: 0;
  margin: 8px auto;
  object-fit: contain;
}
@media screen and (max-width: 1042px) {
  .Diagram {
    max-width: 948px;
    max-height: 489px;
    flex-grow: 0;
    margin: 8px auto;
    object-fit: contain;
  }
}
.Shape {
  width: 285px;
  height: 160px;
  flex-grow: 0;
  padding-left: 1%;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 4px 30px 0 rgba(0, 0, 0, 0.05);
  border: solid 2px #d3352c;
  background-color: #ffffff;
}
.Ellipse {
  width: 32px;
  height: 32px;
  flex-grow: 0;
  margin: 0 auto 8px auto;
  padding: 6px 10px 0px;
  border-radius: 80%;
  background-color: #d3352c;
}
.Value {
  flex-grow: 0;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.17;
  letter-spacing: normal;
  text-align: center;
  color: #ffffff;
  margin: 0;
}
.Detail {
  width: 245px;
  height: 80px;
  flex-grow: 0;
  margin: 8px 0 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.25;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
</style>
